// 通用大按钮 — 复刻 LocalSend BigButton（图标 + 文字，圆角卡片）

import type { ReactNode } from 'react';

interface BigButtonProps {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  filled?: boolean;
  disabled?: boolean;
}

export function BigButton({ icon, label, onClick, filled, disabled }: BigButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        flex flex-col items-center justify-center gap-2
        px-4 py-4 min-w-[110px]
        rounded-lg border transition-all active:scale-95 shadow-btn
        disabled:opacity-50 disabled:cursor-not-allowed
        ${
          filled
            ? 'bg-primary text-primary-fg border-primary hover:bg-primary-600'
            : 'bg-surface text-ink border-border hover:border-primary hover:text-primary'
        }
      `}
    >
      <span className="text-3xl leading-none">{icon}</span>
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
}
